if (!customElements.get('section-body-class-visibility')) {
  class SectionBodyClassVisibility extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[id^="shopify-section-"]');
      this.bodyClass = (this.dataset.bodyClass || '').trim();
      this.mode = this.dataset.mode === 'hide' ? 'hide' : 'show';

      if (!this.section || !this.bodyClass) return;
      if (window.Shopify && Shopify.designMode) return;

      if (this.mode === 'show') {
        this.section.classList.add('section-body-class--controlled');
      }

      this.updateVisibility = this.updateVisibility.bind(this);
      this.updateVisibility();

      this.observer = new MutationObserver(this.updateVisibility);
      this.observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.section?.classList.remove(
        'section-body-class--controlled',
        'section-body-class--visible',
        'section-body-class--hidden'
      );
    }

    updateVisibility() {
      const hasClass = document.body.classList.contains(this.bodyClass);

      if (this.mode === 'hide') {
        this.section.classList.toggle('section-body-class--hidden', hasClass);
        return;
      }

      this.section.classList.toggle('section-body-class--visible', hasClass);
    }
  }

  customElements.define('section-body-class-visibility', SectionBodyClassVisibility);
}
